import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Accordion } from '@ui/molecules/Accordion';
import { translate } from '@utils/i18n';
const namespace = 'features.inspection_ai_summary';
function getContent(iimRunStatus, aiSummary) {
    if (iimRunStatus === 'in_progress') {
        return translate('status.in_progress', { namespace });
    }
    if (iimRunStatus === 'pending') {
        return translate('status.pending', { namespace });
    }
    if (iimRunStatus === 'failed') {
        return translate('status.failed', { namespace });
    }
    return aiSummary || translate('status.no_issues', { namespace });
}
export default function InspectionAiSummary({ iimRunStatus, aiSummary }) {
    const handleViewFullAnalysis = (e) => {
        e.stopPropagation();
        const tab = document.querySelector('a[href="#iim-issues"]');
        tab === null || tab === void 0 ? void 0 : tab.click();
    };
    const content = getContent(iimRunStatus, aiSummary);
    return (React.createElement("div", { style: { marginBottom: '1rem' } },
        React.createElement(Accordion, { title: translate('title', { namespace }), variant: "inline", defaultExpanded: false, actions: [
                {
                    label: translate('view_full_analysis', { namespace }),
                    icon: React.createElement("i", { className: "fa-light fa-sparkles", "aria-hidden": "true" }),
                    buttonProps: {
                        onClick: handleViewFullAnalysis
                    }
                }
            ] },
            React.createElement(ReactMarkdown, null, content))));
}
